// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2AZgs","col":"Table_col__3YfFX","fulfillmentStatus":"Table_fulfillmentStatus__25_Pv","emailCol":"Table_emailCol__1SyxX"};